export default __webpack_public_path__ + "static/bangladesh-6913448c18dc1c60f5847f3b9aa44ff8.png";